$(() => {
  $('.hamburger-menu, #hMenuZab, #hCloseBtn').on('click', (e) => {
    $('.bar').toggleClass('animate');

    if ($('#hMenu').is(':visible')) {
      $('#hMenuZab').toggle();
      $('header').css({ position: 'relative', 'z-index': '1' });
      $('.hamburger-menu').css('position', 'absolute');
      $('#hMenuInner').css({ 'padding-top': '4px' });
      $('article').css({ position: 'static' });
      $('html, body').animate(
        {
          scrollTop: 0,
        },
        300,
      );
      $('#hMenu').animate(
        {
          scrollTop: 0,
        },
        300,
      );
    } else {
      setTimeout(function () {
        $('#hMenuZab').toggle();
        $('header').css({ position: 'fixed', 'z-index': '100' });
        $('.hamburger-menu').css({ position: 'fixed' });
        $('#hMenuInner').css({ 'padding-top': '65px' });
        $('article').css({ position: 'fixed' });
      }, 150);
    }
    $('#hMenu').slideToggle();
  });

  $('.hMenuSection01 a').on('click', (e) => {
    $('#user_current_pet_id').val($(e.currentTarget).data('id'));
    $('#current_pet_field').submit();
  });

  $('a.disable-questionnaire').on('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    const name = $(e.currentTarget).data('clinicname');
    swal(
      `${name}は事前問診に対応していない病院です。\n恐れ入りますが、主訴や病状などは病院へ直接お伝えください。`,
    );
  });
});
